// Temporary pause for finder reads; the audit-refresh trigger is separate.
// Full-job/critical-data TBDAudit payloads are unaffected.
export const TBD_FINDER_PAUSED = true;
export const TBD_REFRESH_TRIGGER_PAUSED = false;
